module.exports = __webpack_public_path__ + "static/benefits-2-a3b566fc1f133bbae959f5165dc47f6e.png";